import Vue from 'vue';

// @ts-ignore missing definitions
import Girder from '@girder/components/src';

Vue.use(Girder);
